import {
  registerCustomDetailComponent,
  registerFormInputComponent,
} from '@vendure/admin-ui/core';

import { registerBulkEditBadgesAction } from './bulk-edit-badges';
import { ColorFormInputComponent } from './color-form-input.component';
import { IntegerTextFormInputComponent } from './integer-text-form-input.component';
import { ProductDetailFormListenerComponent } from './product-detail-form-listener.component';
import { ProductVariantDetailFormListenerComponent } from './product-variant-form-listener.component';

export default [
  registerFormInputComponent('color-form-input', ColorFormInputComponent),
  registerFormInputComponent(
    'string-input-with-int-conversion',
    IntegerTextFormInputComponent,
  ),
  registerCustomDetailComponent({
    locationId: 'product-detail',
    component: ProductDetailFormListenerComponent,
  }),
  registerCustomDetailComponent({
    locationId: 'product-variant-detail',
    component: ProductVariantDetailFormListenerComponent,
  }),
  registerBulkEditBadgesAction,
];
